import { createContext } from 'react';
import type { WebAppConfig } from '../model/types';

export const AppConfigContext = createContext<WebAppConfig | null>(null);
